export default [
  { "key": "ko-KR", "val": "한국어" },
  { "key": "en-US", "val": "English" },
  { "key": "fr-FR", "val": "Français" },
  { "key": "de-DE", "val": "Deutsch" },
  { "key": "ja-JP", "val": "日本語" },
  { "key": "zh-CN", "val": "简体中文" },
  { "key": "zh-TW", "val": "繁體中文" },
  { "key": "es-ES", "val": "Español" },
  { "key": "it-IT", "val": "Italiano" },
  { "key": "ru-RU", "val": "Русский" },
  { "key": "pt-PT", "val": "Português" },
  { "key": "ar-SA", "val": "العربية" },
  { "key": "hi-IN", "val": "हिन्दी" },
  { "key": "tr-TR", "val": "Türkçe" },
  { "key": "pl-PL", "val": "Polski" },
  { "key": "nl-NL", "val": "Nederlands" },
  { "key": "sv-SE", "val": "Svenska" },
  { "key": "da-DK", "val": "Dansk" },
  { "key": "fi-FI", "val": "Suomi" },
  { "key": "no-NO", "val": "Norsk" },
  { "key": "cs-CZ", "val": "Čeština" },
  { "key": "sk-SK", "val": "Slovenčina" },
  { "key": "el-GR", "val": "Ελληνικά" },
  { "key": "th-TH", "val": "ไทย" },
  { "key": "ms-MY", "val": "Melayu" },
  { "key": "vi-VN", "val": "Tiếng Việt" },
  { "key": "ro-RO", "val": "Română" },
  { "key": "hu-HU", "val": "Magyar" },
  { "key": "he-IL", "val": "עברית" },
  { "key": "id-ID", "val": "Bahasa Indonesia" },
  { "key": "uk-UA", "val": "Українська" },
  { "key": "sr-RS", "val": "Српски" },
  { "key": "hr-HR", "val": "Hrvatski" },
  { "key": "bg-BG", "val": "Български" },
  { "key": "sq-AL", "val": "Shqip" },
  { "key": "km-KH", "val": "ខ្មែរ" },
  { "key": "bn-IN", "val": "বাংলা" },
  { "key": "ta-IN", "val": "தமிழ்" },
  { "key": "te-IN", "val": "తెలుగు" },
  { "key": "ml-IN", "val": "മലയാളം" },
  { "key": "gu-IN", "val": "ગુજરાતી" },
  { "key": "mr-IN", "val": "मराठी" },
  { "key": "pa-IN", "val": "ਪੰਜਾਬੀ" },
  { "key": "or-IN", "val": "ଓଡ଼ିଆ" },
  { "key": "as-IN", "val": "অসমীয়া" },
  { "key": "ne-NP", "val": "नेपाली" },
  { "key": "si-LK", "val": "සිංහල" },
  { "key": "ky-KG", "val": "Кыргызча" },
  { "key": "uz-UZ", "val": "O'zbek" },
  { "key": "ps-AF", "val": "پښتو" },
  { "key": "fa-IR", "val": "فارسی" },
  { "key": "ks-IN", "val": "کشميري" },
  { "key": "ta-LK", "val": "தமிழ்" },
  { "key": "sw-KE", "val": "Kiswahili" },
  { "key": "am-ET", "val": "አማርኛ" },
  { "key": "yo-NG", "val": "Yoruba" },
  { "key": "zu-ZA", "val": "Zulu" },
  { "key": "xh-ZA", "val": "Xhosa" },
  { "key": "st-ZA", "val": "Sesotho" },
  { "key": "lt-LT", "val": "Lietuvių" },
  { "key": "lv-LV", "val": "Latviešu" },
  { "key": "et-EE", "val": "Eesti" },
  { "key": "mt-MT", "val": "Malti" },
  { "key": "is-IS", "val": "Íslenska" },
  { "key": "af-ZA", "val": "Afrikaans" },
  { "key": "ca-ES", "val": "Català" },
  { "key": "eu-ES", "val": "Euskara" },
  { "key": "gl-ES", "val": "Galego" },
  { "key": "mk-MK", "val": "Македонски" },
  { "key": "bs-BA", "val": "Bosanski" }
]
